import gql from "graphql-tag";

import { FunctionNode } from "../../../../../types";
import {
  FUNCTION_PARAMETER_FRAGMENT,
  FUNCTION_ATTRIBUTE_FRAGMENT
} from "../../../../common/FunctionEditor/useFunctionEditor/queries";

export type FunctionWithParametersQuery = { node: FunctionNode };
export const FUNCTION_WITH_PARAMETERS = gql`
  query FunctionParameters($functionId: ID!) {
    node(id: $functionId) {
      ... on FunctionNode {
        id
        isUserGenerated
        title
        name
        metadata
        dataSource {
          id
        }
        functionParameters {
          edges {
            node {
              ...FunctionParameterFragment
            }
          }
        }
        functionAttributes {
          edges {
            node {
              ...FunctionAttributeFragment
            }
          }
        }
      }
    }
  }
  ${FUNCTION_PARAMETER_FRAGMENT}
  ${FUNCTION_ATTRIBUTE_FRAGMENT}
`;
